export default __webpack_public_path__ + "static/copilot-official-partner-64283c31ebad83c7952825d2a0d087ac.png";